import React from "react";

export const PageTitle = ({title}) => {
    return (
        <div className="col-md-12">
            <div className="row">
                <div className="col-md-12">
                    <h1 className="back-title">{title}</h1>
                </div>
            </div>
        </div>
    );
};